<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Промо страницы</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <AdsCampaignTable
                            class="mt-4"
                            :list.sync="data"
                            @select="(id) => $router.push(`ads-campaigns/${id}`)"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`ads-campaigns/create`)"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import AdsCampaignTable from '@/components/ads-campaigns/AdsCampaignTable';
    import AdsCampaignTabLinks from '@/components/ads-campaigns/AdsCampaignTabLinks';

    export default {
        name: 'AdsCampaignList',

        components: {
            AdsCampaignTable,
            AdsCampaignTabLinks
        },

        data() {
            return {
                loading: true,
                data: [],
            };
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const response = await this.axios.get('/ads-campaigns');
                this.data = response.data;
            },
        },
    };
</script>
